export const miscTranslations = {
  en: {
    "notFound.title": "404",
    "notFound.message": "Oops! Page not found",
    "notFound.returnHome": "Return to Home",
  },
  zh: {
    "notFound.title": "404",
    "notFound.message": "抱歉，页面未找到",
    "notFound.returnHome": "返回首页",
  },
} as const;
